<template>
  <FreeInput
    ref="formInputRef"
    :model-value="value"
    :label="label"
    :has-error="hasError"
    :placeholder="placeholder"
  >
    <template #errorMessage>
      {{ errorMessage }}
    </template>
    <template #clearButton>
      <FreeCloseButton />
    </template>
  </FreeInput>
</template>

<script setup lang="ts">
  import { useTemplateRef } from 'vue';

  import { FreeInput } from '../FreeInput';
  import { FreeCloseButton } from '../FreeCloseButton';

  interface Props {
    value: string;
    label: string;
    placeholder: string;
    errorMessage?: string;
    hasError?: boolean;
  }

  defineProps<Props>();

  const formInputRef = useTemplateRef('formInputRef');

  defineExpose({
    formInputRef,
  });
</script>
